import { render, staticRenderFns } from "./attachment-strip.vue?vue&type=template&id=56aae276&scoped=true"
import script from "./attachment-strip.vue?vue&type=script&lang=ts"
export * from "./attachment-strip.vue?vue&type=script&lang=ts"
import style0 from "./attachment-strip.vue?vue&type=style&index=0&id=56aae276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aae276",
  null
  
)

export default component.exports